import axios, { type AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { caseKeys } from "src/query-keys";
import type { APIError } from "src/types";

export type CaseCopyMutationData = { caseName: string };

export function useCopyCase(caseId: number) {
  const queryClient = useQueryClient();
  async function mutationFn(caseName: string) {
    await axios.post(`/planning-api/cases/${caseId}/copyWithScenarios`, { caseName });
  }
  return useMutation<void, AxiosError<APIError[]>, string>(mutationFn, {
    onSettled: async () => {
      await queryClient.invalidateQueries(caseKeys.all);
    },
  });
}
